import { BaseComponent } from '../../components/base-component'
import { CartDrawer } from './cart-drawer'
import { replaceNodeChildren } from '../../utils/dom'
import { $el, $elParent } from 'src/scripts/utils/utils'

const CART_DRAWER_SELECTOR = 'cart-drawer'
const CART_DRAWER_TIMER_BLOCK_SELECTOR = 'cart-drawer-timer-block'

export class CartDrawerTimerBlock extends BaseComponent {
  mountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.on('update-nodes', this.handleCartDrawerUpdate)
  }

  unmountComponent(): void {
    const cartDrawer: CartDrawer = $elParent(CART_DRAWER_SELECTOR, this)
    cartDrawer?.off('update-nodes', this.handleCartDrawerUpdate)
  }

  handleCartDrawerUpdate = ({ node }): void => {
    replaceNodeChildren(
      this,
      $el(
        `${CART_DRAWER_TIMER_BLOCK_SELECTOR}[block-id="${this.getAttribute(
          'block-id',
        )}"]`,
        node,
      ),
    )
  }
}
